import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ArchiveUpdateConfirmDialog = ({ open, onClose, onOnlyUpdate, onUpdateAll, content, hideOnlyUpdate }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="archive-update-confirm-title"
            maxWidth="sm"
            fullWidth
            sx={{ zIndex: 13001 }}
        >
            <DialogTitle id="archive-update-confirm-title">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    Archive Question Update
                    <IconButton aria-label="close" onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {content || "Want to Update this changes over this Archived question or update changes to all account where used this question ?"}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3, px: 3 }}>
                <Button
                    onClick={onUpdateAll}
                    variant="outlined"
                    sx={{ textTransform: 'none' }}
                >
                    Update with all account
                </Button>
                {!hideOnlyUpdate && (
                    <Button
                        onClick={onOnlyUpdate}
                        variant="outlined"
                        sx={{ textTransform: 'none' }}
                    >
                        Only Update this
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ArchiveUpdateConfirmDialog;
